/** @format */

import { SkuDescriptiveAttribute } from './sku-descriptive-attribute.interface';
import { ProductSku } from './product-sku.interface';

export interface Shipping {
  comingSoon?: string;
  isHazmat: ProductSku['isHazmat'];
  // Once we have hot market products again, verify whether this is string or number
  isHotMarket?: SkuDescriptiveAttribute['value'];
  isPreSale: ProductSku['preSale'];
  isRestricted: ProductSku['shippingRestricted'];
  leadTime: ProductSku['leadTime'];
  preSaleDate?: string;
  shippingClass: ProductSku['shipClass'];
}
